import { Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React from 'react';

import * as S from './style';

function DetailGroup({ className, header, title, children }) {
  return (
    <S.DetailGroupWrapper className={className}>
      {header}
      {title && (
        <Typography variant="body1Bold" style={{ marginBottom: '16px' }}>
          {title}
        </Typography>
      )}
      <S.GroupContent>{children}</S.GroupContent>
    </S.DetailGroupWrapper>
  );
}

DetailGroup.propTypes = {
  className: PropTypes.string,
  header: PropTypes.node,
  title: PropTypes.string,
  children: PropTypes.node
};

export { DetailGroup };
